import baustein from "baustein";
import rothko from "web/script/modules/rothko";
import template from "templates/modules/product/related_products_section.jinja";
import RelatedProductsShowMore from "web/react/components/related-products-show-more/related-products-show-more";
import renderReactComponentInDocument from "web/script/utils/render-react";

export default baustein.register("related-products-more-from-designer", {
    template,

    /**
     * fetches and renders the lazy loaded tabbed section
     * However, since we're not rendering the `is` property,
     * the tabbed section will no longer be a baustein component
     */
    fetchAndRender() {
        const { slug, uid } = this.options;

        rothko
            .fetch("modules/product/related_products_more_from_designer", { slug, uid })
            .then((data) => {
                this.setRenderContext({
                    section: data,
                });
                return data;
            })
            .then((data) => {
                renderReactComponentInDocument(
                    RelatedProductsShowMore,
                    {
                        view_more_url: data.view_more_url,
                        product_is_instock: data.product_is_instock,
                    },
                    this.el.querySelector("related-products-show-more-button-" + data.section_type)
                );
            });
    },
});
